import isPresent from '../../../../Common/Utils/Present';

const CanViewPrice = (formData, index) => (
  formData && isPresent(formData.ad_campaign) &&
  isPresent(formData.ad_campaign.creatives_attributes) &&
  isPresent(formData.ad_campaign.creatives_attributes[index]) &&
  isPresent(formData.ad_campaign.creatives_attributes[index].competes)
);

export default CanViewPrice;



// WEBPACK FOOTER //
// ./src/views/Components/Campaigns/Site/Helpers/CanViewPrice.tsx